import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import LegalPageLayout from "./LegalPageLayout";

const content = {
  fr: {
    title: "Politique de Confidentialité",
    lastUpdated: "Dernière mise à jour : Avril 2026",
    sections: [
      {
        title: "Collecte des données",
        intro: "Nous collectons les données suivantes lorsque vous utilisez LëtzServices :",
        items: [
          "Nom et adresse email (lors de l'inscription)",
          "Photo de profil (optionnel)",
          "Contenu des annonces et messages",
          "Données de connexion (adresse IP, navigateur)",
        ],
      },
      {
        title: "Utilisation des données",
        intro: "Vos données sont utilisées pour :",
        items: [
          "Gérer votre compte et vos annonces",
          "Permettre la communication entre utilisateurs",
          "Améliorer nos services",
          "Envoyer des notifications importantes",
        ],
      },
      {
        title: "Protection des données",
        text: "Conformément au RGPD, vos données sont stockées de manière sécurisée au sein de l'Union Européenne. Nous ne vendons jamais vos données personnelles à des tiers.",
      },
      {
        title: "Vos droits",
        intro: "Vous avez le droit de :",
        items: [
          "Accéder à vos données personnelles",
          "Rectifier vos données",
          "Supprimer votre compte et vos données",
          "Exporter vos données",
        ],
      },
      {
        title: "Cookies",
        text: "Nous utilisons des cookies essentiels pour le fonctionnement du site (authentification, préférences). Aucun cookie publicitaire n'est utilisé.",
      },
      {
        title: "Contact",
        text: "Pour toute question concernant vos données : letzservicesinfo@gmail.com",
      },
    ],
  },
  en: {
    title: "Privacy Policy",
    lastUpdated: "Last updated: April 2026",
    sections: [
      {
        title: "Data Collection",
        intro: "We collect the following data when you use LëtzServices:",
        items: [
          "Name and email address (during registration)",
          "Profile picture (optional)",
          "Content of listings and messages",
          "Connection data (IP address, browser)",
        ],
      },
      {
        title: "Use of Data",
        intro: "Your data is used to:",
        items: [
          "Manage your account and listings",
          "Enable communication between users",
          "Improve our services",
          "Send important notifications",
        ],
      },
      {
        title: "Data Protection",
        text: "In accordance with GDPR, your data is stored securely within the European Union. We never sell your personal data to third parties.",
      },
      {
        title: "Your Rights",
        intro: "You have the right to:",
        items: [
          "Access your personal data",
          "Rectify your data",
          "Delete your account and data",
          "Export your data",
        ],
      },
      {
        title: "Cookies",
        text: "We use essential cookies for site operation (authentication, preferences). No advertising cookies are used.",
      },
      {
        title: "Contact",
        text: "For any questions about your data: letzservicesinfo@gmail.com",
      },
    ],
  },
};

const PrivacyPolicyPage = () => {
  const { lang } = useLanguage();
  return <LegalPageLayout content={content[lang] || content.fr} />;
};

export default PrivacyPolicyPage;
